import { Discount } from "./Types/discountTypes";
const today = new Date().toISOString().slice(0, 10);
export const discountValue: Discount = {
	name: "",
	id: 0,
	usePercentage: false,
	discountPercentage: 0,
	discountAmount: 0,
	startDate: today,
	endDate: today,
	bookingIds: [],
};
